module.exports = __webpack_public_path__ + "static/media/coke.62d4ecc0.png";